// ConsolidatedFilter's badge and Reset controls remain baseline-aware.
export function activeFilterGroups(dimensions, selections, baseline = {}, checked = false) {
  return dimensions.filter(({ id }) => {
    const selected = selections[id];
    if (selected === undefined) return false;
    const base = baseline[id] ?? (checked ? dimensions.find((dim) => dim.id === id).options.map(({ value }) => value) : []);
    return selected.length !== base.length || selected.some((value) => !base.includes(value));
  });
}

// Search explanations describe effective restrictions, not changes from defaults.
// Empty/absent groups and groups selecting every option are unrestricted.
export function restrictedFilterGroups(dimensions, selections, checked = false) {
  return dimensions.filter(({ id, options }) => {
    const selected = selections[id];
    return (checked ? options.length > 0 && selected !== undefined : selected?.length > 0)
      && (!options.length || options.some(({ value }) => !selected.includes(value)));
  });
}

export function relaxFilterGroups(selections, groups, checked = false) {
  const next = { ...selections };
  // Do not delete keys: on Leases an absent status key restores default gates.
  for (const { id, options } of groups) next[id] = checked ? options.map(({ value }) => value) : [];
  return next;
}

export function summarizeFilterGroups(groups, selections, checked = false) {
  if (groups.length !== 1) return `${groups.length} active filters`;
  const { id, label, options } = groups[0];
  const labels = (selections[id] ?? []).map((value) =>
    options.find((option) => option.value === value)?.label ?? value);
  return `${label}: ${labels.length ? labels.join(", ") : checked ? "None" : "All"}`;
}

// Callers supply the same searched/non-facet-eligible population on both sides.
// A set difference (not row-count subtraction) handles repeated entity IDs.
export function deriveFilterHiddenSearch({ query, groups, selections, candidates, visible, checked = false }) {
  const trimmedQuery = (query ?? "").trim();
  if (!trimmedQuery || !groups.length) return null;
  const visibleIds = new Set(visible.map((row) => row.id));
  const hiddenIds = new Set(candidates
    .filter((row) => row.id != null && !visibleIds.has(row.id))
    .map((row) => row.id));
  if (!hiddenIds.size) return null;
  return {
    count: hiddenIds.size,
    query: trimmedQuery,
    summary: summarizeFilterGroups(groups, selections, checked),
  };
}
